import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0adfc2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = { class: "flex-row-centered" }
const _hoisted_4 = { class: "flex-col-centered selection" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "owner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Owner:")
], -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "flex-col-centered" }
const _hoisted_8 = { class: "link-btn" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  style: {"display":"flex"}
}
const _hoisted_13 = ["onClick"]

import { ref, onMounted, computed } from "vue";
// Services
import { insuranceClaims } from "@/services/network";
import InsuranceClaimsPopUp from "@/components/InsuranceClaimsPopUp.vue"
import InsuranceClaimsEditPopUp from "@/components/InsuranceClaimsEditPopUp.vue";
import InsuranceCommentPopUp from "@/components/InsuranceCommentPopUp.vue";
import IInsuranceClaimsGetQuery from "@/Interfaces/InsuranceClaims/IInsuranceClaimsGetQuery"
import { contractOwners as contractOwnersNetworkService } from "@/services/network";
// Components
import MarketSelector from '@/components/MarketSelector.vue';
// Misc
import { DisplayableKeys } from "@/services/SorterService";
import { marketSelection, ownerSelection } from "@/services/helpers/Helper";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

// Table
import Table from "@/components/TablePersistentChecking.vue";
import DateIgnoreTime from "@/types/DateIgnoreTime";
import TickCrossBooleanDisplay from "@/components/TickCrossBooleanDisplay.vue";
import IInsuranceForm from "@/Interfaces/InsuranceClaims/IInsuranceClaimsForm";
import { ContractOwner } from "@/models/CarPurchases/ContractOwner";


export default /*#__PURE__*/_defineComponent({
  __name: 'InsuranceClaims',
  setup(__props) {

const contractOwners = ref<ContractOwner[]>([]);
const unfilteredContractOwners = ref<ContractOwner[]>([]);
const defaultSortOrders = ref<(1|-1)[]>([-1]);
const defaultSortCols = ref([4]);
const expandedCols = ref(false)
const colsExpanded: DisplayableKeys<IInsuranceForm>[] = ["contractId", "vin", "registrationNumber", "isCompleted", "ticketId", "paymentDate", "caseReferenceId", "fullAmount", "excessAmount", "companyName", "companyVatId", "companyLocation", "comments", "userEmail", "isCompleted"];
const labelsExpanded = [ "Contract ID", "VIN", "Registration Number", "Completed", "Ticket ID", "Payment Date", "Case Reference ID", "Full Amount", "Excess Amount", "Company Name", "Company VAT ID", "Company Location", "Comments", "Reporter", "Edit"]
const colsNormal: DisplayableKeys<IInsuranceForm>[] = ["contractId", "vin", "registrationNumber", "isCompleted", "ticketId", "paymentDate", "fullAmount", "excessAmount", "comments", "userEmail", "isCompleted"];
const labelsNormal = [ "Contract ID", "VIN", "Registration Number", "Completed", "Ticket ID", "Payment Date", "Full Amount", "Excess Amount", "Comments", "Reporter", "Edit"]
const cols = computed(() => {return  expandedCols.value ? colsExpanded : colsNormal; });
const labels = computed(() => {return  expandedCols.value ? labelsExpanded : labelsNormal; });
const working = ref(false);
const insuranceRows =ref<IInsuranceForm[]>();
const selectedRow = ref<IInsuranceForm>();
const insurancePopUpStatus = ref(false);
const commentPopUpContent = ref<IInsuranceForm>();
const newCommentInsertedPopUp = ref(false);

onMounted(async () => {
    document.title = "Insurance Claims - UV";
    insuranceRows.value = undefined;
    await GetContractOwners();
    await SetContractOwnerByMarket();
    await SetDefaultOwner();
    await getTableData()
});
async function updateMarketSelection(){
    await SetContractOwnerByMarket();
    await SetDefaultOwner();
    getTableData()
}
async function GetContractOwners() {
    try {
        const res = (await contractOwnersNetworkService.get()).data
        
        unfilteredContractOwners.value = res;
    } catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: "Contract Owners",
            error,
        });
    }
}
async function SetContractOwnerByMarket(){
    contractOwners.value = unfilteredContractOwners.value.filter( x => x.Market == marketSelection.value).sort((a, b) => {
                const aId = a?.OwnerId ?? "";
                const bId = b?.OwnerId ?? "";
                return bId.localeCompare(aId);
            }); 
}
async function SetDefaultOwner(){
    try{
        ownerSelection.value = contractOwners.value[0].OwnerId ?? "";
    }
    catch{
        console.warn("Contract owners were not loaded");
    }
}
async function getTableData(){
    if(working.value) return;    
    try{
        working.value=true
        insuranceRows.value = undefined;
        const request: IInsuranceClaimsGetQuery = {
            market: marketSelection.value, 
            owner: ownerSelection.value
        }
        const response = await insuranceClaims.get(request);
        let responseData = response.data;
        responseData.map(x => x.paymentDate = new DateIgnoreTime(x.paymentDate))
        insuranceRows.value = responseData
    }catch (error) {
        useNotifierWithErrFormatter().error({error});
    }
    working.value=false
}
function displayEditPopUp(row: IInsuranceForm){
    selectedRow.value = row
}
function ViewComment(row: IInsuranceForm){
    commentPopUpContent.value = row;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(MarketSelector, {
            enableSE: "",
            onChange: updateMarketSelection
          }),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(ownerSelection) ? (ownerSelection).value = $event : null)),
              class: "dropdown",
              required: "",
              id: "owner",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (getTableData()))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractOwners.value, (contractOwner) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: contractOwner.OwnerId,
                  key: contractOwner.OwnerId
                }, _toDisplayString(contractOwner.FullName), 9, _hoisted_6))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(ownerSelection)]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "submit-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (insurancePopUpStatus.value=!insurancePopUpStatus.value))
            }, " New Claim ")
          ])
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createTextVNode(" ["),
      _createElementVNode("a", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (expandedCols.value = !expandedCols.value))
      }, _toDisplayString(expandedCols.value ? "Collapse Rows" : "Expand Rows"), 1),
      _createTextVNode("] ")
    ]),
    _createVNode(Table, {
      Rows: insuranceRows.value,
      Cols: cols.value,
      Labels: labels.value,
      SplitColKeys: "",
      DefaultSortCols: defaultSortCols.value,
      DefaultSortOrders: defaultSortOrders.value
    }, {
      "isCompleted-1": _withCtx(({value}) => [
        _createElementVNode("button", {
          class: "table-button",
          disabled: value.isCompleted,
          onClick: ($event: any) => (displayEditPopUp(value))
        }, " Edit ", 8, _hoisted_9)
      ]),
      isCompleted: _withCtx(({value}) => [
        _createVNode(TickCrossBooleanDisplay, {
          value: value.isCompleted
        }, null, 8, ["value"])
      ]),
      comments: _withCtx((props) => [
        (props.value.comments)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "overflow-text",
                onClick: ($event: any) => (ViewComment(props.value)),
                title: `View Full Comment in Popup`
              }, _toDisplayString(props.value.comments), 9, _hoisted_11)
            ]))
          : _createCommentVNode("", true),
        (props.value.comments == null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "table-button",
                onClick: ($event: any) => (ViewComment(props.value))
              }, " Add Comment ", 8, _hoisted_13)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["Rows", "Cols", "Labels", "DefaultSortCols", "DefaultSortOrders"]),
    _createVNode(InsuranceClaimsPopUp, {
      modelValue: insurancePopUpStatus.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((insurancePopUpStatus).value = $event)),
      disableDefaultToolTip: true,
      market: _unref(marketSelection),
      onConfirm: getTableData
    }, null, 8, ["modelValue", "market"]),
    _createVNode(InsuranceClaimsEditPopUp, {
      modelValue: selectedRow.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedRow).value = $event)),
      disableDefaultToolTip: true,
      onConfirm: getTableData
    }, null, 8, ["modelValue"]),
    _createVNode(InsuranceCommentPopUp, {
      modelValue: commentPopUpContent.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((commentPopUpContent).value = $event)),
      onClose: _cache[8] || (_cache[8] = ($event: any) => (newCommentInsertedPopUp.value=false)),
      onConfirm: getTableData
    }, null, 8, ["modelValue"])
  ]))
}
}

})